import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONDITION_TYPE_DROPDOWN: `${cleanedFilename(
    __filename,
  )}-condition-type-dropdown`,
};
